exports.university = {
	courses: [
		// { этот курс просили скрыть на время урл задачи https://app.clickup.com/t/pvdj35?modestbranding=1
		// 	get: 0,
		// 	url: 'amazon-dropshipping-titans',
		// 	course: {
		// 		title: "Amazon Dropshipping Titans from Paul J Lipsky",
		// 		description: "Heard those stories about people selling six figures online with an Automated Amazon store?<br>You don't need to spend tens of thousands of dollars to get started. Learn the simple secret that helped me create a thriving Amazon store on autopilot.<br>Break Into the Largest Marketplace in The World With The Most Comprehensive Program Available!"
		// 	},
		// 	video: {
		// 		title: "Paul J Lipsky",
		// 		marker: "",
		// 		description: "Paul J Lipsky is a seven-figure dropshipper who sold millions of products online through his innovative methods. He then quit his job as an attorney in New York City to pursue dropshipping full-time while traveling around the country.<br>Now Paul has the most subscribed channel on YouTube about eBay and Amazon dropshipping. His mission is to empower others to use dropshipping to achieve financial freedom and live out their dreams.",
		// 		picture: {
		// 			desk: '/img/new/lipsky.jpg',
		// 			doubleDesk: '/img/new/lipsky@1_5x.jpg',
		// 			mob: '/img/new/lipsky@mob.jpg',
		// 			doubleMob: '/img/new/lipsky@mob1_5x.jpg'
		// 		},
		// 		price: {
		// 			full: "$4,042.99",
		// 			total: "$699.99"
		// 		},
		// 		data: {
		// 			query: "start-profitable-amazon-business",
		// 			label: "Start Profitable Amazon Business With $1,000 in 60 Days Without Website, Inventory, or Experience",
		// 			link: "https://www.youtube.com/embed/ZOMalEG6Pg4?modestbranding=1"
		// 		}
		// 	},
		// 	offer: {
		// 		title: 'Amazon Dropshipping Titans Course - detailed instruction about profiting with Dropshipping <b><del>$1,997</del></b>',
		// 		bonuses: [{text: "Advanced modules for making more money on every sale with almost no extra work <span>BONUS</span> <del>$499</del>"}, {text: "Customer Service Scripts for creating returning customers <span>BONUS</span> <del>$99</del>"},{text: "Private Facebook mentoring group for support, get help with overcoming obstacles and everyday hurdles <span>BONUS</span> <del>$999</del>"}, {text: "Exact criteria to choose winning product checklist <span>BONUS</span> <del>$99</del>"}, {text: "Everyday must-do tasks to keep profit growing list <span>BONUS</span> <del>($99 value)</del>"}],
		// 		tools: [{name: "PRO Extension"}, {name: "Product Database"}, {name: "Product Tracker"}, {name: "Reverse ASIN Lookup"}, {name: "Amazon Keyword Search"}, {name: "Keyword Tracker Basic"}, {name: "QuickView"}, {name: "Seller's Course"}, {name: "1,000+ Exclusive Amazon products & niches"}, {name: "12 Monthly Trends Reports"}]
		// 	},
		// 	cta: {
		// 		description: "ALL THIS FOR ONLY  <span>$4,042.99</span>  <span>$699.99</span>!",
		// 		title: "Get the Tools, Training and Bonuses for only $699.99",
		// 		href: "/get/bundle0810"
		// 	}
		// },
		{
			get: 0,
			url: 'super-amazon-seller',
			course: {
				title: "Amazon Course SAS “SuperAmazonSeller” from Riley Turner",
				description: "All the knowledge and training you need to launch your Amazon FBA business!<br>- Select profitable products using Riley’s advanced research methods<br>- Get a reliable supplier and negotiate the best offer for your private label product<br>- Create a listing that stands out from competitors, attracts customers, and is selling your product<br>- Run ads, sell the product on several platforms, and monitor your revenue<br>Most importantly, with this Amazon course, you’ll receive personal mentorship. Riley will watch every step of launching your business and help with any issue!"
			},
			video: {
				title: "Riley Turner",
				marker: "",
				description: "Riley is a 7-figure online seller, who has taught hundreds of students how to go full-time with Amazon. Prior to learning about the Amazon business from a random YouTube subscription, he didn’t believe that it was possible to make money so rapidly.<br>Now, Riley has made many of his dreams come true and he isn’t stopping there.<br/>What makes it worth it for Riley is that he wants other people to be free from 9-to-5 jobs and have a great life.",
				picture: {
					desk: '/img/new/riley-turner.jpg',
					doubleDesk: '/img/new/riley-turner@1_5x.jpg',
					mob: '/img/new/riley-turner@mob.jpg',
					doubleMob: '/img/new/riley-turner@mob1_5x.jpg'
				},
				price: {
					full: "$8,653.99",
					total: "$649.99"
				},
				data: {
					query: "double-your-money-in-30-days ",
					label: "[Webinar] - Double Your Money in 30 Days on Amazon. Sell at Higher Margins Than Your Competitor!",
					link: "https://www.youtube.com/embed/iQuKyUbx7lc?modestbranding=1"
				}
			},
			offer: {
				title: 'SUPERIOR AMAZON SELLER COURSE - <b><del>$1,997</del></b><br><br>Finding FBA Winning Products, Finding a Supplier, Signing Up and Dashboard Walkthrough<br><br>UNLIMITED ONE ON ONE MENTORSHIP - <b><del>$2,997</del></b><br><br>Account Setup, Finding a Supplier, Finding Winning Products, Listing a New Product',
				bonuses: [
					{text: "<div>PRIVATE FACEBOOK GROUP - Network & Learn With Other Successful Students In Our Private Facebook Community! <span>BONUS</span> <del>$999</del></div>"},
					{text: "<div>Riley's Easy To Use Profit Calculator, Supplier Contact Template, Step By Step Flow Chart & More Useful Tools! <span> BONUS</span> <del>$999</del></div>"},
					{text: "<div>BUSINESS CONNECTIONS - Avoid Stress & Save Time By Using Riley's Preferred Specialists For Shipping, Marketing <span>BONUS</span> <del>$797</del></div>"},
					{text: "<div>Unlock Exclusive Discounts SAVING You HUNDREDS on Essential Services, Software & Tools! <span>BONUS</span> <del>$497</del></div>"}
				],
				tools: [
					{name: "PRO Extension"},
					{name: "Product Database"},
					{name: "Product Tracker"},
					{name: "Reverse ASIN Lookup"},
					{name: "Amazon Keyword Search"},
					{name: "Keyword Tracker Basic"},
					{name: "Quick View"},
					{name: "Seller's Course"},
					{name: "1,000+ Exclusive Amazon products & niches"},
					{name: "12 Monthly Trends Reports"}
				]
			},
			cta: {
				description: "ALL THIS FOR ONLY <span>$8,653.99</span> <span>$649.99</span>",
				title: "Get the Tools, Training and Bonuses for only $649.99",
				href: "/checkout/?bundle=universityriley"
			}
		},
		{
			get: 1,
			url: 'proven-amazon-course',
			course: {
				title: "Proven Amazon Course from Jim Cockrum",
				description: "Get the complete Amazon guide with step-by-step details on everything you need to know (for all experience levels): <br/>" +
					"- The unique Replens strategy explained: Go from $0 to $100k/mo. Find 30 Replens in 30 days and keep track of them. Hire and manage a team, and build your workflow. Expand to wholesale, private label, and much more.<br/>" +
					"- It does not matter whether you’re going to do private label or dropshipping - this course includes content for any model<br/>" +
					"- Learn all the ins and outs of Amazon selling methods to build a successful multi-income business. This includes product partnering, a merch course, and team building.<br/>" +
					"- Increase your profit using bundles. Learn about product choice, sourcing, packaging, pricing, listing for bundles, and advanced bundling strategies."
			},
			video: {
				title: "Jim Cockrum",
				marker: "",
				description: "Jim has been actively selling on Amazon and eBay since 1997. He has run Amazon seller coaching programs for 10+ years and has over 7,000 happy students.<br/>" +
					"Jim has appeared in the Wall Street Journal, Entrepreneur Magazine, Men's Health Magazine, eBay Radio, and in countless news and radio programs as an internet and online business expert.",
				picture: {
					desk: '/img/new/jim-cockrum.jpg',
					doubleDesk: '/img/new/jim-cockrum@1_5x.jpg',
					mob: '/img/new/jim-cockrum@mob.jpg',
					doubleMob: '/img/new/jim-cockrum@mob1_5x.jpg'
				},
				price: {
					full: "$7,637.99",
					total: "$699.99"
				},
				data: {
					query: "make-300k-selling-low-risk-products",
					label: "Make $300K/Year Selling Low-Risk Products with Local Suppliers",
					link: "https://www.youtube.com/embed/F64A9YHyg1c?modestbranding=1"
				}
			},
			offer: {
				title: 'Amazon 101 Course for New Sellers - <b><del>$297</del></b><br><br>' +
					'The #1 reason people don’t start their Amazon business is due to a lack of step-by-step instructions. Watch this course and learn what you can do right now to build your business.<br><br>' +
					'Replens Training - <b><del>$97</del></b><br><br>' +
					'Contains 12+ hours of content! Go from $0 to $100k/mo. Find 30 Replens in 30 days and keep track of them. Hire and manage a team, and build your workflow. Expand to wholesale, Private Label, and much more.<br><br>' +
					'Wholesale Sourcing 2.0 - <b><del>$297</del></b><br><br>' +
					'A video series from 4 top expert sellers. The sellers will reveal secrets for finding wholesale deals, both locally and globally. Understand how to approach wholesalers and brand owners live or virtually.<br><br>' +
					'Private Labeling 3.0 - <b><del>$497</del></b><br><br>' +
					'A simple and low-risk way to do Private Label. Find profitable products and affordable suppliers. Make listings that will bring customers. Launch with a proven ads strategy and get sales.',
				bonuses: [
					{text: "<div>2021 Live Conference Videos - provides access to 30 videos. These videos include training and education taught by real people who DO the business and love helping others. Focus on multiple income streams to grow your business. <span>BONUS</span> <del>$399</del></div>"},
					{text: "<div>Bundling Workshop - increase your profit using bundles. Learn about product choice, sourcing, packaging, pricing, listing for bundles, and advanced bundling strategies.<span> BONUS</span> <del>$127</del></div>"},
					{text: "<div>Importing from China - a PDF book with decades of experience to make your work simple. Learn about sourcing directly with real manufacturers, using Alibaba correctly, minimizing your risks, and getting the best price with no haggling.<span> BONUS</span> <del>$97 value</del></div>"},
					{text: "<div>Buy Local, Sell to the World - your comprehensive guide to finding local treasures and flipping them to a global audience for huge profits. Build a 6-figure business easily and quickly using these simple proven strategies.<span> BONUS</span> <del>$97 value</del></div>"},
					{text: "<div>Promotional Company Sourcing - a course on sourcing profitable private-label products to sell on Amazon. Follow step-by-step and learn how to use promotional companies to find a gold mine of opportunities!<span> BONUS</span> <del>$327</del></div>"},
					{text: "<div>Fulfillment by Merchant Training - an in-depth course on fulfilment. Includes how to determine shipping costs for merchant-fulfilled inventory, cost-saving USPS shipping services, and more.<span> BONUS</span> <del>$197</del></div>"},
					{text: "<div>50 More Modules for Every Level of Amazon Seller - learn all the ins and outs of Amazon selling methods to build a successful multi-income business. This includes product partnering, a merch course, and team building.<span> BONUS</span> <del>$5,000</del></div>"},
				],
				tools: [
					{name: "PRO Extension"},
					{name: "Amazon Dropshipping & Arbitrage tool"},
					{name: "Product Database"},
					{name: "Product Tracker"},
					{name: "Reverse ASIN Lookup"},
					{name: "Amazon Keyword Search"},
					{name: "Stock Stats"},
					{name: "Seller's Course"},
					{name: "1,000+ Exclusive Amazon products & niches"},
					{name: "12 Monthly Trends Reports"}
				]
			},
			cta: {
				description: "ALL THIS FOR ONLY <span>$7,637,99</span> <span>$699.99</span>",
				title: "Get the Tools, Training and Bonuses for only $699.99",
				href: "/checkout/?bundle=bundlejim"
			}
		},
		{
			get: 2,
			url: 'best-amazon-course',
			course: {
				title: "“The Best Amazon Course” from Gabriel Thornton",
				description: "Training is crucial when searching for a new product that sells, whether a seller is just starting out, or has a few years behind their back. The Best Amazon Course will walk you step-by-step to discover new products and grow your business." +
					"<br>- Instantly learn if a product is worth it" +
					"<br>- Watch ADVANCED tactics and learn SECRETS to select high-demand products with low competition for FBA" +
					"<br>- Learn the exact search parameters to apply to get a top product EVERY TIME!" +
					"<br>- Receive clear, \"real-world\" feedback to remain free from stagnation in product research, and learn product idea generation HACKS the gurus are hiding" +
					"<br>- Understand how to get in the perfect mindset to pick out a great product for your Amazon business",
			},
			video: {
				title: "Gabriel Thornton",
				marker: "",
				description: "Gabriel launched his business in 2015, and now makes money selling a bunch of items online through Amazon FBA. Gabriel has consulted other Amazon businesses on a subscription basis and has seen hundreds of private label products go live. Through this, Gabriel learned first-hand insight into what makes a product succeed.",
				picture: {
					desk: '/img/new/gabriel-thornton.jpg',
					doubleDesk: '/img/new/gabriel-thornton@1_5x.jpg',
					mob: '/img/new/gabriel-thornton@mob.jpg',
					doubleMob: '/img/new/gabriel-thornton@mob1_5x.jpg'
				},
				price: {
					full: "$2,046.99",
					total: "$699.99"
				},
				data: {
					query: "the-best-amazon-course",
					label: "\"The Best Amazon Course\" from Gabriel Thornton",
					link: "https://www.youtube.com/embed/tKiMNJ7vq70?modestbranding=1"
				}
			},
			offer: {
				title: '“The Best Amazon Course” - <b><del>$ 997</del></b><br><br>The most in-depth product research course ever. Learn how to select profitable products that won’t stagnate and sit on the shelf. The course includes brainstorming tricks that many gurus don’t share, and marketing strategies that encourage product breakthrough.',
				bonuses: [
					{text: "<div>Two Free 30-Minute Training Call with Gabriel - You may use the call whenever you’d like. We can go over any challenges you have or I can audit your product choice <span>BONUS</span> <del>$200</del></div>"},
					{text: "<div>Unlimited Emailing - Once the training call is completed, you can keep up with Gabriel through email <span> BONUS</span> <del>$500</del></div>"},
					{text: "<div>Product Research Criteria Sheet - Decide at a glance if a product is a winner or loser, and if you should move forward with it <span>BONUS</span> <del>$997 value</del></div>"},
					{text: "<div>Top Products Not To Sell Master List - This sheet saves a lot of new sellers from going for the products they tend to go for, but should actually stay away from <span>BONUS</span> <del>$200 value</del></div>"},
					{text: "<div>Pre-Launch Profit Estimator Sheet - This is a detailed and formulated sheet that allows students to estimate how much money they should expect to spend and regain for their initial launch <span>BONUS</span> <del>$200 value</del></div>"},
				],
				tools: [
					{name: "PRO Extension"},
					{name: "Product Database"},
					{name: "Product Tracker"},
					{name: "Reverse ASIN Lookup"},
					{name: "Amazon Keyword Search"},
					{name: "Keyword Tracker Basic"},
					{name: "Quick View"},
					{name: "Seller's Course"},
					{name: "1,000+ Exclusive Amazon products & niches"},
					{name: "12 Monthly Trends Reports"}
				]
			},
			cta: {
				description: "ALL THIS FOR ONLY <span>$2,046.99</span> <span>$699.99</span>",
				title: "Get the Tools, Training and Bonuses for only $699.99",
				href: "/checkout/?bundle=universitygabriel"
			}
		},
		{
			get: 3,
			url: 'home-business-expert',
			course: {
				title: "“HomeBusinessExpert” Amazon Dropshipping Course from Amy Hunt",
				description: "Are you interested in an additional income stream from Amazon without risking your money?<br/>" +
					"Amy teaches how to sell on Amazon in an easy-to-start-and-scale way.<br/>" +
					"This Amazon dropshipping course covers every step of selling on Amazon, from finding the best products to reducing your costs, and setting up automation for scaling your business! Amy will cover what a dropshipping selling model is, and how her unique twist makes it easier to do.<br/>" +
					"This course is a great fit for both beginner sellers and those looking to scale their dropshipping business. Over 12,000 students are already learning how to make money online from Amy - join them now!"
            },
			video: {
				title: "Amy Hunt",
				marker: "",
				description: "Amy started selling on Amazon to be able to stay at home with her newborn. She started 17 years ago and has kept going ever since!<br/>" +
					"Amy has sold out of stock at Kmart, Walmart, and Lego.com on many occasions. She reached $500-$1,000 a day per single online store.<br/>" +
					"Amy has made it her specialty to help others transition from 9-5 jobs to earning incomes selling from home.",
                picture: {
					desk: '/img/new/amy-hunt.jpg',
					doubleDesk: '/img/new/amy-hunt@1_5x.jpg',
					mob: '/img/new/amy-hunt@mob.jpg',
					doubleMob: '/img/new/amy-hunt@mob1_5x.jpg'
				},
				price: {
					full: "$797.99",
					total: "$449.99"
				},
				data: {
					query: "know-if-a-product-will-sell",
					label: "Know if a product will sell in only one week",
					link: "https://www.youtube.com/embed/VFsTd-AwHiY?modestbranding=1"
				}
			},
			offer: {
				title: 'Amy Hunt\'s Dropshipping Course - <b><del>$ 199</del></b><br><br>Set-up Your Business From the Start, Making It Easy to Scale, and Including Automatic Listing Tools To Increase Profit',
				bonuses: [
					{text: "<div>2 products / niches feedback - Amy will check 2 products and niches you plan to sell for consistent high demand, competition levels, and confirm if you can sell them for long term profit <span>BONUS</span> <del>$199</del></div>"},
					{text: "<div>16 Steps to Selling On Amazon & Daily Checklist - Step-by-Step Daily Checklist To Creating A Successful Amazon Business <span> BONUS</span> <del>$99</del></div>"}
                ],
				tools: [
					{name: "PRO Extension"},
					{name: "Amazon Dropshipping & Arbitrage tool"},
					{name: "Product Database"},
					{name: "Product Tracker"},
					{name: "Reverse ASIN Lookup"},
					{name: "Amazon Keyword Search"},
					{name: "Stock Stats"},
					{name: "Seller's Course"},
					{name: "1,000+ Exclusive Amazon products & niches"},
					{name: "12 Monthly Trends Reports"}
				]
			},
			cta: {
				description: "ALL THIS FOR ONLY <span>$797.99</span> <span>$449.99</span>",
				title: "Get the Tools, Training and Bonuses for only $449.99",
				href: "/checkout/?bundle=bundleamy"
			}
		},
		{
			get: 4,
			url: 'amazon-fba-mastery',
			course: {
				title: "Amazon FBA Mastery from Just One Dime with Seth Kniep",
				description: "Build an income to enjoy the things you love and share them with people who are important to you. Learn how to start selling on Amazon in a clear, step-by-step way.<br/>" +
					"Learn strategies to generate an enormous passive income stream from the Amazon FBA Mastery Course. During this course, you’ll learn hacks that very few sellers know that will help you grow your money faster.<br/>" +
					"Learn tactics to reduce your business costs and improve your sales month by month."
			},
			video: {
				title: "Seth Kniep",
				marker: "Most Experienced Dropshipper",
				description: "Living paycheck-to-paycheck and having $24,000 in debt, Seth Kniep took a single dime and set a goal of growing it into $100,000 to create freedom for him and his family.<br/>" +
					"Today, Seth’s team creates brands and stores for investors on Amazon and provides coaching for a new generation of entrepreneurs.<br/>" +
					"Seth and his Just One Dime team have helped over 10,000 sellers in 150+ countries - 32 of those sellers are multi-millionaires now.<br/>" +
					"To help their members get high-quality products at the best price, Just One Dime has a sourcing operation in China.",
				picture: {
					desk: '/img/new/set_kniep.jpg',
					doubleDesk: '/img/new/set_kniep@1_5x.jpg',
					mob: '/img/new/set_kniep@mob.jpg',
					doubleMob: '/img/new/set_kniep@mob1_5x.jpg'
				},
				price: {
					full: "$16,375",
					total: "$1,997"
				},
				data: {
					query: "9-steps-to",
					label: "9 Steps to Find a Low Competition $9,000/month Product",
					link: "https://www.youtube.com/embed/ViPcgmQdupQ?modestbranding=1"
				}
			},
			offer: {
				title: '<b>Amazon FBA Mastery Course 1</b><br>Establish your business & brand <b>(<del>$1,997</del> value)</b><br><br><b>Amazon FBA Mastery Course 2</b><br>Master the market <b>(<del>$1,997</del> value)</b><br><br><b>Amazon FBA Mastery Course 3</b><br>Manufacture your product <b>(<del>$1,997</del> value)</b><br><br><b>Amazon FBA Mastery Course 4</b><br>Launch your brand <b>(<del>$1,997</del> value)</b><br><br><b>Amazon FBA Mastery Course 5</b><br>Expand your reach <b>(<del>$1,997</del> value)</b>',
				bonuses: [
					{text: "Amazon FBA Mastery membership"},
					{text: "<div>Product research dominance <span>BONUS</span> <del>$997</del></div>"},
					{text: "<div>Product launch & rank <span>BONUS</span> <del>$497</del></div>"},
					{text: "<div>PPC mastery <span>BONUS</span> <del>$997</del></div>"},
					{text: "<div>Lawyer training for brand protection <span>BONUS</span> <del>$247</del></div>"},
					{text: "<div>Business mastery <span>BONUS</span> <del>$997</del></div>"},
					{text: "<div>Trademark mastery <span>BONUS</span> <del>$997</del></div>"},
					{text: "<div>Product reviews <span>BONUS</span> <del>$497</del></div>"},
				],
				tools: [
					{name: "PRO Extension"},
					{name: "Product Database"},
					{name: "Product Tracker"},
					{name: "Reverse ASIN Lookup"},
					{name: "Amazon Keyword Search"},
					{name: "Keyword Tracker Basic"},
					{name: "Quick View"},
					{name: "Seller's Course"},
					{name: "1,000+ Exclusive Amazon products & niches"},
					{name: "12 Monthly Trends Reports"}
				]
			},
			cta: {
				description: "ALL THIS FOR ONLY  <span>$16,375</span>  <span>$1,997</span>",
				title: "Get the Tools, Training and Bonuses for only $1,997",
				href: "https://members.justonedime.com/checkout/?rid=pvq1e2"
			}
		},
		{
			get: 5,
			url: 'amz-insiders-course',
			course: {
				title: "AMZ Insiders Course from Jamie Davidson",
				description: "Learn how to start out on Amazon and scale your business without investing tons of money or spending all your time on it. Instead of trying to piece together how to sell on Amazon, use a working strategy from an 8-figure seller:<br/>" +
					"- Select high-demand and low competition products to reduce inventory cost<br/>" +
					"- Discover sourcing tricks that will save you $5,000 the moment you implement them<br/>" +
					"- Learn ranking and launching tactics that will skyrocket your sales so you can outperform competitors<br/>" +
					"- Put your reviews on autopilot without breaking Amazon policies"
			},
			video: {
				title: "Jamie Davidson",
				marker: "",
				description: "Jamie is an Amazon coach and a co-founder of AMZ Insiders. They sell $100,000,000 per year online through FBA Private Label.<br/>" +
					"Jamie is also a West Point graduate and a former Army Officer and was the CEO of a private equity-backed company until 2013.<br/>" +
					"Jamie now invests a lot of effort into helping new and upcoming entrepreneurs hit 6 and 7 figures on Amazon through his AMZ Insiders Course.",
				picture: {
					desk: '/img/new/jamie-davidson.jpg',
					doubleDesk: '/img/new/jamie-davidson@1_5x.jpg',
					mob: '/img/new/jamie-davidson@mob.jpg',
					doubleMob: '/img/new/jamie-davidson@mob1_5x.jpg'
				},
				price: {
					full: "$3,249.99",
					total: "$799.99"
				},
				data: {
					query: "build-a-7-figure-income",
					label: "Build a 7 figure income with just one product",
					link: "https://www.youtube.com/embed/CDW5hcqgw_E?modestbranding=1"
				}
			},
			offer: {
				title: 'Insiders Pro Academy Membership - <b><del>$ 2,900</del></b>',
				bonuses: [
					{text: "<div>“Winning Product Selection” Training  - How to find the perfect high profit product to build a 7-figure Amazon business that will not lose your money <span>BONUS</span></div>"},
					{text: "<div>“Product Sourcing Secrets” Training  - Learn sourcing secrets that will literally save you $5,000 as soon as you implement them <span> BONUS</span></div>"},
					{text: "<div>“Launching & Ranking Secrets” Training  - Discover The Exact Page 1 Ranking Strategy that will crush your competition <span>BONUS</span></div>"},
					{text: "<div>“Amazon Review Secrets” Training  - The new safe way to grow your reviews quickly and on auto-pilot that is compliant with Amazon policies <span>BONUS</span></div>"}],
				tools: [
					{name: "PRO Extension"},
					{name: "Product Database"},
					{name: "Product Tracker"},
					{name: "Reverse ASIN Lookup"},
					{name: "Amazon Keyword Search"},
					{name: "Keyword Tracker Basic"},
					{name: "Quick View"},
					{name: "Seller's Course"},
					{name: "1,000+ Exclusive Amazon products & niches"},
					{name: "12 Monthly Trends Reports"}
				]
			},
			cta: {
				description: "ALL THIS FOR ONLY <span>$3,249.99</span> <span>$799.99</span>",
				title: "Get the Tools, Training and Bonuses for only $799.99",
				href: "/checkout/?bundle=bundledavidson"
			}
		},
		{
			get: 6,
			url: 'amz-limitless-course',
			course: {
				title: "Amz Limitless™ Amazon Course from Ryan Ford",
				description: "Use the same steps and tactics that enabled Ryan Ford to create and put his 7-figure Amazon business on autopilot.<br/>" +
					"Have Ryan himself help you deal with any challenges and mentor you for Amazon success for 3 months!<br/>" +
					"Start your Amazon business the right way from the beginning! Watch hours of continuously updated video training on private label product launch. Enjoy the freedom that having a business on autopilot brings, and the free time to do the things you love!"
			},
			video: {
				title: "Ryan Ford",
				marker: "",
				description: "Ryan is one of the best eCom experts and a digital nomad, selling over $1 million per year in revenue. He has launched several online brands with a lineup of successful products in each brand. Ryan has helped more than 1,000 sellers with his Amazon course see that it was worth it, and build great FBA businesses on autopilot.",
				picture: {
					desk: '/img/new/ryan-ford.jpg',
					doubleDesk: '/img/new/ryan-ford@1_5x.jpg',
					mob: '/img/new/ryan-ford@mob.jpg',
					doubleMob: '/img/new/ryan-ford@mob1_5x.jpg'
				},
				price: {
					full: "$6,593.99",
					total: "$699.99"
				},
				data: {
					query: "double-your-money-in-30-days ",
					label: "[Webinar] - Double Your Money in 30 Days on Amazon. Sell at Higher Margins Than Your Competitor!",
					link: "https://www.youtube.com/embed/JoJef6a3k34?modestbranding=1"
				}
			},
			offer: {
				title: 'AMZ Limitless Course - <b><del>$1,997</del></b><br><br>Everything about selling on Amazon. Includes updates to avoid new pitfalls on Amazon and ramp up your sales!',
				bonuses: [
					{text: "<div>3 month subscription to Ryan’s private mentorship to ensure you don't get stuck or miss any part of a successful product launch <span>BONUS</span> <del>$3,600</del></div>"},
					{text: "<div>Suspension Prevention Amazon Course - Learn how to make sure your account is safe from suspension so you can continue to make money <span> BONUS</span> <del>$497</del></div>"},
					{text: "<div>A private Facebook community with successful sellers sharing the best insights and tips on how to increase revenue and deal with challenges <span>BONUS</span> <del>$150</del></div>"},
				],
				tools: [
					{name: "PRO Extension"},
					{name: "Product Database"},
					{name: "Product Tracker"},
					{name: "Reverse ASIN Lookup"},
					{name: "Amazon Keyword Search"},
					{name: "Keyword Tracker Basic"},
					{name: "Quick View"},
					{name: "Seller's Course"},
					{name: "1,000+ Exclusive Amazon products & niches"},
					{name: "12 Monthly Trends Reports"}
				]
			},
			cta: {
				description: "ALL THIS FOR ONLY <span>$6,593.99</span> <span>$699.99</span>",
				title: "Get the Tools, Training and Bonuses for only $699.99",
				href: "/checkout/?bundle=universityford"
			}
		},

		// {
		// 	get: 5,
		// 	url: 'dropshipping-master-course',
		// 	course: {
		// 		title: "Ecommerce University Dropshipping Master Course",
		// 		description: "This course covers everything you need to know about starting and maintaining a successful Dropshipping Amazon Business from A-Z. It's made for people who are complete beginners and who know nothing about Amazon as well as for those looking for inside information. Andrew shares all of his tips and tricks about how to run an effective and efficient 6-figure Amazon Dropshipping Business. Make use of pre-made formulas where you simply plug in numbers and names of products and you can instantly see if the product is worth selling. Customer Service Templates and Order Spreadsheets included. Take advantage of this opportunity and start your journey to complete and ultimate financial freedom."
		// 	},
		// 	video: {
		// 		title: "Andrew Giorgi",
		// 		marker: "",
		// 		description: "Andrew Giorgi is a Full-Time Amazon Dropshipper with over $500,000 in sales. After selling on Amazon for 3 years, Andrew has explored every business model available.  He has handled 99% of possible problems/issues/roadblocks that this business can throw at you & has successfully made it out to the other side.  Andrew is now running his own 6-figure Amazon Dropshipping Automation Service.",
		// 		picture: {
		// 			desk: '/img/new/andrew-giorgi.jpg',
		// 			doubleDesk: '/img/new/andrew-giorgi@2x.jpg',
		// 			mob: '/img/new/andrew-giorgi@mob.jpg',
		// 			doubleMob: '/img/new/andrew-giorgi@mob2x.jpg'
		// 		},
		// 		price: {
		// 			full: "$3,194.99",
		// 			total: "$699.99"
		// 		},
		// 		data: {
		// 			query: "double-your-money-in-30-days ",
		// 			label: "[Webinar] - Double Your Money in 30 Days on Amazon. Sell at Higher Margins Than Your Competitor!",
		// 			link: "https://www.youtube.com/embed/rTTRuFLV0Qw?modestbranding=1"
		// 		}
		// 	},
		// 	offer: {
		// 		title: 'Product Research Training  LIFETIME  <b><del>$999</del></b>',
		// 		bonuses: [{text: "3 Mentorship Consultations <span>BONUS</span> <del>$450</del>"}, {text: "Setting Up Inventory Management and Repricing Software Training <span> BONUS</span> <del>$399</del>"},{text: "Ecommerce Listing Items and Order Fulfilment Training <span>BONUS</span> <del>$299</del>"}, {text: "Setting Up Amazon Account Training <span>BONUS</span> <del>$399</del>"}, {text: "Accounts Metrics and Amazon Customer Service Training <span>BONUS</span> <del>$297</del>"}],
		// 		tools: [{name: "PRO Extension"}, {name: "Product Database"}, {name: "Product Tracker"}, {name: "Reverse ASIN Lookup"}, {name: "Amazon Keyword Search"}, {name: "Keyword Tracker Basic"}, {name: "QuickView"}, {name: "Seller's Course"}, {name: "Exclusive Insights, 26 niches + 26 products"}, {name: "12 Monthly Trends Reports"}]
		// 	},
		// 	cta: {
		// 		description: "ALL THIS FOR ONLY <span>$3,194.99</span> <span>$699.99</span>",
		// 		title: "Get the Tools, Training and Bonuses for only $699.99",
		// 		href: "/checkout/?bundle=bundle1510"
		// 	}
		// }

		// закрыть курс по задаче - https://app.clickup.com/t/12pmmu6
		// {
		// 		get: 5,
		// 		url: 'amazon-fba-and-dropshipping',
		// 		course: {
		// 			title: "Amazon FBA & Dropshipping Course from Arturo Knight",
		// 			description: "Learn to find profitable products, source them from the best suppliers in both the US and Asia, and master every other step of a business on Amazon: <br>- Create easy-to-find attractive listings that sell your product. <br>- Run cost-effective Pay Per Click ad campaigns to grow sales and maintain high profit margins. <br>- Use hacks for Amazon rankings to get your product listed in top Amazon search results and have your product seen by more customers.<br>- Process orders and ship items to Amazon. <br>- Provide the best customer service to get top reviews that attract new customers."},
		// 		video: {
		// 			title: "Arturo Knight",
		// 			marker: "",
		// 			description: "Arturo is an well-known Entrepreneur, Influencer, E-commerce Mentor and Pro Musician. He is on a mission to free as many people as possible from their 9-5 jobs, and to help them experience the true power of entrepreneurship. <br>Arturo has already guided 10,000+ students through reaching their financial goals and living the life of their dreams, and now he is ready to help you! <br>He has been featured on Yahoo, Future Sharks, Disrupt, CNN, and FOX for his achievements.",
		// 			picture: {
		// 				desk: '/img/new/arturo-knight.jpg',
		// 				doubleDesk: '/img/new/arturo-knight@1_5x.jpg',
		// 				mob: '/img/new/arturo-knight@mob.jpg',
		// 				doubleMob: '/img/new/arturo-knight@mob1_5x.jpg'
		// 			},
		// 			price: {
		// 				full: "$4,849.99",
		// 				total: "$549.99"
		// 			},
		// 			data: {
		// 				query: "double-your-money-in-30-days ",
		// 				label: "[Webinar] - Double Your Money in 30 Days on Amazon. Sell at Higher Margins Than Your Competitor!",
		// 				link: "https://www.youtube.com/embed/KESKn7oXHQQ?modestbranding=1"
		// 			}
		// 		},
		// 		offer: {
		// 			title: 'Amazon FBA Set Up & Product Research Training - <b><del>$ 897</del></b><br>Finding FBA Winning Products, Finding a Supplier, Signing Up and Dashboard Walkthrough<br><br>Amazon Dropshipping Product Research Training - <b><del>$ 997</del></b><br>Account Setup, Finding a Supplier, Finding Winning Products, Listing a New Product',
		// 			bonuses: [
		// 				{text: "Amazon FBA Sales Training - Listing an FBA Product, Sending Products to Amazon, Amazon Ads for FBA, Listing Optimization for Customer Attraction, Positive Relationships with Suppliers and Customers <span>BONUS</span> <del>$1,219</del>"},
		// 				{text: "Amazon Dropshipping Processing Training - Processing Orders, Getting Tax Exempt, Getting Cash Back <span> BONUS</span> <del>$300</del>"},
		// 				{text: "Amazon Dropshipping Sales Training - Listing Optimization for Customer Attraction, Pay Per Click Advertising, Keeping Your Account Healthy, How to Deal with a Suspended Account <span>BONUS</span> <del>$587</del>"},
		// 				{text: "30 Minute Q&A Call with Arturo - Deal with blockers and get tips for your specific business from Arturo <span>BONUS</span> <del>$500</del>"},
		// 				{text: "Amazon Launch Guide PDF - 12 Simple steps for establishing your successful Amazon busines <span>BONUS</span> <del>$49 value</del>"}
		// 			],
		// 			tools: [
		// 				{name: "PRO Extension"},
		// 				{name: "Product Database"},
		// 				{name: "Product Tracker"},
		// 				{name: "Reverse ASIN Lookup"},
		// 				{name: "Amazon Keyword Search"},
		// 				{name: "Keyword Tracker Basic"},
		// 				{name: "Quick View"},
		// 				{name: "Seller's Course"},
		// 				{name: "1,000+ Exclusive Amazon products & niches"},
		// 				{name: "12 Monthly Trends Reports"}
		// 			]
		// 		},
		// 		cta: {
		// 			description: "ALL THIS FOR ONLY <span>$4,849.99</span> <span>$549.99</span>",
		// 			title: "Get the Tools, Training and Bonuses for only $549.99",
		// 			href: "/checkout/?bundle=bundlearturo"
		// 		}
		// 	},
		]
}
